<template>
  <article class="new_post">
    <div class="new_post-banner"></div>
    <div class="new_post-content base_content">
      <div class="new_post-title base_title"> {{ $route.name }}</div>
      <div class="new_post-body">
        <form class="add_post" @submit.prevent="editing ? editPost : newPost">
          <div class="form_row">
            <div class="form_column">
              <input type="text" placeholder="Название" class="input_wide" required
                autocomplete="off" v-model="post.name">
              <input type="text" placeholder="Категория" autocomplete="off"
                class="input_wide" v-model="post.category">
            </div>
            <div class="form_column">
              <fileInput :text="post.coverImage ? post.coverImage : 'Выбрать обложку'"
                v-model="post.coverImage"/>
            </div>
            <div class="form_column">
              <label for="ldt" class="inline-object">
                <span class="label_text" v-if="editing">Дата публикации</span>
                <span class="label_text" v-else>Отложить публикацию</span>
                <input type="datetime-local" placeholder="Отложить публикацию"
                  id="ldt" class="datetime_wide" v-model="post.datePosted">
              </label>
              <checkBox text="Отображать в лаунчере" :inverted="true"
                v-model="post.lShow"/>
            </div>
          </div>
          <VueEditor v-model="post.fullText" :editorToolbar="customToolbar"/>
          <button type="submit" class="btn download_button">Сохранить</button>
        </form>
      </div>
    </div>
  </article>
</template>
<script>
import { VueEditor } from 'vue2-quill-editor';
import checkBox from '@/components/checkBox';
import fileInput from '@/components/fileInput';
import Backend from '@/services/backend.service';

export default {
  name: 'NewPost',
  components: { VueEditor, checkBox, fileInput },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ['code-block', 'formula', 'blockqoute'],
        ['link', 'image', 'video'],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ header: [1, 2, 3, false] }],
        ['clean'],
      ],
      backend: new Backend(),
      post: {
        name: null,
        fullText: null,
        coverImage: null,
        datePosted: null,
        lShow: true,
      },
    };
  },
  methods: {
    newPost() {
      const formData = new FormData();
      Object.keys(this.post).forEach((key) => {
        formData.append(key, this.post[key]);
      });
      this.backend.post('/posts', formData)
        .then((resp) => {
          console.log(resp);
        })
        .catch(err => console.error(err));
    },
    editPost() {
      const formData = new FormData();
      Object.keys(this.post).forEach((key) => {
        formData.append(key, this.post[key]);
      });
      this.backend.patch('/posts', formData)
        .then((resp) => {
          console.log(resp);
        })
        .catch(err => console.error(err));
    },
    retrievePost() {
      this.backend.get(`/post/${this.$route.params.uid}`)
        .then((resp) => {
          this.post.name = resp.title;
          this.post.fullText = resp.full;
          this.post.lShow = resp.showLauncher;
          this.post.category = resp.category;
          this.post.coverImage = resp.image;
          this.post.datePosted = new Date(resp.posted * 1000).toISOString().slice(0, 16);
        })
        .catch(err => console.error(err));
    },
  },
  mounted() {
    console.log(this.$route);
    if (this.editing) this.retrievePost();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.new_post{
  &-banner{
    aspect-ratio: 16/4;
    width: 100%;
    background: url('/static/lk-banner.jpg') no-repeat 50% 50% / cover;
    pointer-events: none;
  }
  &-content{
    padding: 20px 0;
  }
  &-body{
    max-width: 75%;
    margin: 0 auto;
    .quillWrapper{
      margin: 20px 0;
      border-radius: 4px;
    }
    .download_button{
      width: 100%;
    }
    .add_post{
      .form_row{
        user-select: none;
      }
      .form_row:first-child{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .form_column{
        .input_wide:first-child{
          margin-bottom: 15px;
        }
        label:first-child{
          margin-bottom: 15px;
        }
        .inline-object{
          .label_text{
            display: block;
            min-width: 113px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/NewPost.vue